import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from "moment";
import { ErrorOutline, CompareArrows } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { validatePermission } from 'helpers/authentication';
import { errorAlert } from 'helpers/alerts';
import { BackButton, FilterBar, TableData } from "components";
import { setErrorCodesProvider, setErrorCodesHistoryProvider, setProviderErrorCodeToCreate, setErrorCodesHistoryIdsProvider } from 'redux/slices/admin/providerSlice';
import { getProviderCredsErrorCodesService, getProviderCredsErrorCodesHistoryService, getAllProviderCredsService } from 'services/admin/providerService';
import { Grid } from '@mui/material';

function ErrorCodesRecibidosScreen() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [update, setUpdate] = useState(0);
  const { current, errorCodesProvider, hebeErrorCodesHistoryList } = useSelector(store => store.providers)
  const errorCodesList = errorCodesProvider.map((e) => e.externalExceptionCode);
  const [filters, setFilters] = useState(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    getProviderCredsErrorCodesService(current.host)
      .then(response => dispatch(setErrorCodesProvider(response)))
      .catch(error => errorAlert(error));
  }, [update]);



  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mt={2}
      >
        <div>
          <BackButton click={() => navigate('../..')} />
        </div>
        <div className="container-title">
          <div className="title">Proveedor</div>
          <div className="subtitle">{current.container_name}</div>
        </div>
        <div style={{ width: "170px" }}></div>
      </Grid>
      <FilterBar
        handlerFilter={async (data) => {
          setLoading(true)
          setFilters(data)
          getProviderCredsErrorCodesHistoryService(current.host, data)
            .then(response => dispatch(setErrorCodesHistoryProvider(response)))
            .catch(error => errorAlert(error))
            .finally(() => setLoading(false))
        }}
        defaultValues={{
          date: [moment().subtract(30, 'days').toDate(), new Date()],
        }}
        allValue={null}
        filters={[
          {
            type: "dates",
            name: "date",
            label: "Fecha",
          },
          {
            name: 'state',
            label: "Estado",
            type: "select",
            data: [
              { name: "Todos" },
              { id: true, name: "Mapeados" },
              { id: false, name: "No Mapeados" },
            ],
          },
        ]}
      />
      <TableData
        dataRows={hebeErrorCodesHistoryList}
        loading={loading}
        dataTitle={[
          "Homologado",
          "Error Code",
          "Message",
          "Count"
        ]}
        formatter={({ code, message, count }) => ([
          (errorCodesList.indexOf(code) > -1 ? "SI" : "NO"),
          code,
          message,
          count
        ])}
        actions={[
          validatePermission('proveedores', 'productos', ['editar']) &&
          {
            label: "Homologar",
            icon: <ErrorOutline />,
            validate: (data) => {
              return errorCodesList.indexOf(data.code) == -1
            },
            onClick: (data) => {
              dispatch(setProviderErrorCodeToCreate(data.code));
              navigate("../homologados/create");
            },
          },
          validatePermission('proveedores', 'productos', ['editar']) &&
          {
            label: "Transacciones",
            icon: <CompareArrows />,
            onClick: (data) => {
              navigate('/reportes/detallado', {
                state: {
                  state: 2,
                  code: data.code,
                  date: filters.date,
                  provider: current.host,
                }
              });
            },
          },

        ]}
      />
    </>
  );
}


export default ErrorCodesRecibidosScreen;